/* Editorial presentation only. Destination, stock and shipping remain controller-owned. */
(function () {
  'use strict';
  function present() {
    var controller = window.TntProvinceStock;
    var code = controller && controller.selectedProvince();
    var shipping = {"NL":"Tire shipping: Select sets of 4 ship FREE · 1-3 tires from $11.58/tire · + tax","NB":"Tire shipping: Sets of 4 from $12.49/tire · 1-3 tires from $23.08/tire · + tax","NS":"Tire shipping: Sets of 4 from $12.49/tire · 1-3 tires from $23.08/tire · + tax","PE":"Tire shipping: Sets of 4 from $12.49/tire · 1-3 tires from $23.08/tire · + tax","QC":"Tire shipping: Sets of 4 from $16.13/tire · 1-3 tires from $33.00/tire · + tax","ON":"Tire shipping: Sets of 4 from $16.13/tire · 1-3 tires from $33.00/tire · + tax","MB":"Tire shipping: Sets of 4 from $16.19/tire · 1-3 tires from $33.15/tire · + tax","SK":"Tire shipping: Sets of 4 from $16.19/tire · 1-3 tires from $33.15/tire · + tax","AB":"Tire shipping: Select sets of 4 ship FREE · 1-3 tires from $21.50/tire · + tax","BC":"Tire shipping: Sets of 4 from $42.25/tire · 1-3 tires from $78.32/tire · + tax"};
    document.querySelectorAll('.tnt-hero-benefits').forEach(function (line) {
      line.textContent = shipping[code] || shipping.NL;
    });
    document.querySelectorAll('[data-tnt-buyer-route]').forEach(function (link) {
      var url = new URL(link.dataset.tntBuyerRoute, location.origin);
      if (code) url.searchParams.set('province', code);
      link.setAttribute('href', url.pathname + url.search);
    });
  }
  document.addEventListener('tnt:provinceChanged', present);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', present);
  else present();
})();
